var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mt-3" }, [
    _c("h1", [_vm._v("Account Info")]),
    _c(
      "form",
      {
        staticClass: "ms-4",
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.signUp.apply(null, arguments)
          },
        },
      },
      [
        _c("h3", { staticClass: "mt-3" }, [_vm._v("Generic Info")]),
        _c("div", { staticClass: "mb-3" }, [
          _vm.showError
            ? _c(
                "div",
                { staticClass: "alert alert-danger", attrs: { role: "alert" } },
                [_vm._v(" " + _vm._s(_vm.errorText) + " ")]
              )
            : _vm._e(),
          _c(
            "label",
            {
              staticClass: "form-label float-left",
              attrs: { for: "inputClubName" },
            },
            [_vm._v("Name")]
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.name,
                expression: "name",
              },
            ],
            staticClass: "form-control ms-1",
            attrs: { type: "text", id: "inputClubName", required: "" },
            domProps: { value: _vm.name },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.name = $event.target.value
              },
            },
          }),
        ]),
        _c("div", {}, [
          _c(
            "label",
            {
              staticClass: "form-label float-left",
              attrs: { for: "inputEmail" },
            },
            [_vm._v("Email Address")]
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.emailAddress,
                expression: "emailAddress",
              },
            ],
            staticClass: "form-control ms-1",
            attrs: { type: "email", id: "inputEmail", required: "" },
            domProps: { value: _vm.emailAddress },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.emailAddress = $event.target.value
              },
            },
          }),
          _c(
            "button",
            {
              staticClass: "btn btnAccent my-3 float-right",
              attrs: { type: "button" },
              on: { click: _vm.updateGenericInfo },
            },
            [_vm._v("Save")]
          ),
        ]),
        _c("hr", { staticClass: "rounded" }),
        _c("h3", { staticClass: "mt-3" }, [_vm._v("Password Reset")]),
        _c("div", { staticClass: "mb-3" }, [
          _c(
            "label",
            {
              staticClass: "form-label float-left",
              attrs: { for: "oldPassword" },
            },
            [_vm._v("Old Password")]
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.oldPassword,
                expression: "oldPassword",
              },
            ],
            staticClass: "form-control ms-1",
            attrs: { type: "password", id: "oldPassword", required: "" },
            domProps: { value: _vm.oldPassword },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.oldPassword = $event.target.value
              },
            },
          }),
        ]),
        _c("div", { staticClass: "mb-3" }, [
          _c(
            "label",
            {
              staticClass: "form-label float-left",
              attrs: { for: "password" },
            },
            [_vm._v("Password")]
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.password,
                expression: "password",
              },
            ],
            staticClass: "form-control ms-1",
            attrs: { type: "password", id: "password", required: "" },
            domProps: { value: _vm.password },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.password = $event.target.value
              },
            },
          }),
        ]),
        _c("div", { staticClass: "mb-3" }, [
          _c(
            "label",
            {
              staticClass: "form-label float-left",
              attrs: { for: "passwordConfirm" },
            },
            [_vm._v("Password Confirmation")]
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.passwordConfirm,
                expression: "passwordConfirm",
              },
            ],
            staticClass: "form-control ms-1",
            attrs: { type: "password", id: "passwordConfirm", required: "" },
            domProps: { value: _vm.passwordConfirm },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.passwordConfirm = $event.target.value
              },
            },
          }),
          _c(
            "button",
            {
              staticClass: "btn btnAccent my-3 float-right",
              attrs: { type: "button" },
              on: { click: _vm.updatePassword },
            },
            [_vm._v("Save")]
          ),
        ]),
        _c("hr", { staticClass: "rounded" }),
        _c("h3", { staticClass: "mt-3" }, [
          _vm._v("Stripe Account "),
          !_vm.stripeComplete
            ? _c("i", { staticClass: "ph-bold ph-warning warning" })
            : _vm._e(),
        ]),
        _vm.stripeComplete
          ? _c("p", [
              _vm._v(
                " You already setup your stripe account, navigate to the "
              ),
              _c(
                "a",
                {
                  attrs: {
                    target: "_new",
                    href: "https://dashboard.stripe.com",
                  },
                },
                [_vm._v("Stripe Dashboard")]
              ),
              _vm._v(" to see your information/ validate your account. "),
              _c(
                "button",
                {
                  staticClass: "btn btnAccent mx-2 my-2",
                  attrs: { type: "button" },
                  on: { click: _vm.deauthorizeStripeAccount },
                },
                [_vm._v("Disconnect Stripe")]
              ),
            ])
          : _vm.accountCreated
          ? _c("p", [
              _vm._v(
                " If you did not finish setup click Setup Account Button: "
              ),
              _c(
                "button",
                {
                  staticClass: "btn btnAccent mx-2",
                  attrs: { type: "button" },
                  on: { click: _vm.onboardPayments },
                },
                [_vm._v("Setup Account")]
              ),
              _c("br"),
              _c("i", [
                _vm._v(
                  "If you completed, please wait 1-3 business days and login to"
                ),
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    target: "_new",
                    href: "https://dashboard.stripe.com",
                  },
                },
                [_vm._v("Stripe Dashboard")]
              ),
              _vm._v(" "),
              _c("i", [_vm._v("to see status ")]),
            ])
          : _c("div", { staticClass: "align" }, [
              _vm._v(
                " In order to handle payments within the application, you must create/link a stripe account here: "
              ),
              _c(
                "button",
                {
                  staticClass: "btn btnAccent mx-2",
                  attrs: { type: "button" },
                  on: { click: _vm.onboardPayments },
                },
                [_vm._v("Setup New Account")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btnAccent mx-2",
                  attrs: { type: "button" },
                  on: { click: _vm.connectUser },
                },
                [_vm._v("Connect Existing Account")]
              ),
            ]),
        _c("hr", { staticClass: "rounded" }),
        _c("h3", { staticClass: "mt-3" }, [_vm._v("Delete Vibtap Account")]),
        _c(
          "button",
          {
            staticClass: "btn btnAccent my-3",
            attrs: { type: "button" },
            on: { click: _vm.deleteFullAccount },
          },
          [_vm._v("Delete")]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }